export default __webpack_public_path__ + "static/media/slide-4.1ddf9cbd.png";